export default __webpack_public_path__ + "static/media/project_edit.d5cc2302.svg";